import XUICheckbox from '@xero/xui/react/checkbox';
import { FC } from 'react';

export interface ICheckBoxProps {
    text: string | JSX.Element;
    onCheckBoxChange: (isValid: boolean) => void;
    checkBoxChecked: boolean;
}

const CheckBox: FC<ICheckBoxProps> = ({ text, onCheckBoxChange, checkBoxChecked }) => {
    const onChange = () => {
        onCheckBoxChange(!checkBoxChecked);
    };

    return (
        <XUICheckbox isChecked={checkBoxChecked} onChange={onChange}>
            {text}
        </XUICheckbox>
    );
};

export default CheckBox;
